const MemberActionTypes = Object.freeze({
  FETCH_MEMBERS_START: 'member/FETCH_MEMBERS_START',
  FETCH_MEMBERS_SUCCESS: 'member/FETCH_MEMBERS_SUCCESS',
  FETCH_MEMBERS_FAILURE: 'member/FETCH_MEMBERS_FAILURE',
  NEXT_PAGE: 'member/NEXT_PAGE',
  PREV_PAGE: 'member/PREV_PAGE',
  SET_MEMBER_STATE: 'member/SET_MEMBER_STATE',
  FILTER_MEMBERS: 'FILTER_MEMBERS',
});

export default MemberActionTypes;
